import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { ResendInvitationDocument } from './resendInvitation.gql';

export const useResendInvitation = (companyInvitationId: string) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error("'companyProfileId' is undefined in 'useResendInvitation'");
  }

  return useMutation(ResendInvitationDocument, {
    variables: { input: { companyInvitationId, companyProfileId } },
  });
};
